import { createContext } from 'react';
import { useWarehouseApp } from '../hooks/useWarehouseApp';

type WarehouseAppContextType = ReturnType<typeof useWarehouseApp>;

export const WarehouseAppContext = createContext<WarehouseAppContextType | null>(null);
